import {
  VAT_RECORDING_DOCTYPE,
  DOCUMENT_DIRECTION,
  INTERNAL_INVOICE_OPTION,
  RELATED_INVOICE_OPTION,
  RELATED_INTERNAL_INVOICE_OPTION,
} from './constants'

export const getDataForRender = model => {
  const { individualRecording = {} } = model || {}
  if (individualRecording.documentDirection === DOCUMENT_DIRECTION.Outbound) {
    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.Invoice) {
      // 3.1.1
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.Empty) {
        return {
          basics: [{ key: 'relatedPartyIdentifier', label: 'receiverID' }, 'documentNumber', 'relatedInvoiceOption'],
          taxAmounts: [
            {
              title: 'turnoverAtATaxRateOf20',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtATaxRateOf10',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
            {
              title: 'turnoverWithoutFeeAtTaxRate20S20PdvRsObj',
              label: 'turnoverWithoutFeeAtTaxRate20S20PdvRsObj.tooltip',
              fields: [
                'noChargeRealEstateDescription20',
                'noChargeRealEstateBaseAmount20',
                'noChargeRealEstateCalculatedVat20',
              ],
            },
            {
              title: 'turnoverWithoutFeeAtTaxRate10S10PdvRsObj',
              label: 'turnoverWithoutFeeAtTaxRate10S10PdvRsObj.tooltip',
              fields: [
                'noChargeRealEstateDescription10',
                'noChargeRealEstateBaseAmount10',
                'noChargeRealEstateCalculatedVat10',
              ],
            },
          ],
        }
      }
      // 3.1.2
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.Prepayment) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            { key: 'relatedVatRecords', nestedKey: 'documentNumber', label: 'relatedInvoiceNumberSEF' },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInvoiceNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'turnoverAtATaxRateOf20',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtATaxRateOf10',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
            {
              title: 'turnoverWithoutFeeAtTaxRate20S20PdvRsObj',
              label: 'turnoverWithoutFeeAtTaxRate20S20PdvRsObj.tooltip',
              fields: [
                'noChargeRealEstateDescription20',
                'noChargeRealEstateBaseAmount20',
                'noChargeRealEstateCalculatedVat20',
              ],
            },
            {
              title: 'turnoverWithoutFeeAtTaxRate10S10PdvRsObj',
              label: 'turnoverWithoutFeeAtTaxRate10S10PdvRsObj.tooltip',
              fields: [
                'noChargeRealEstateDescription10',
                'noChargeRealEstateBaseAmount10',
                'noChargeRealEstateCalculatedVat10',
              ],
            },
          ],
        }
      }
    }
    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.CreditNote) {
      // 3.2.1
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.Invoice) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            { key: 'relatedVatRecords', nestedKey: 'documentNumber', label: 'relatedInvoiceNumberSEF' },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInvoiceNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'turnoverAtATaxRateOf20',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtATaxRateOf10',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      // 3.2.2
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.PeriodSelection) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            'relatedInvoiceIssueDateFrom',
            'relatedInvoiceIssueDateTo',
          ],
          taxAmounts: [
            {
              title: 'turnoverAtATaxRateOf20',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtATaxRateOf10',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      // 3.2.3
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.Prepayment) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            { key: 'relatedVatRecords', nestedKey: 'documentNumber', label: 'relatedInvoiceNumberSEF' },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInvoiceNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJOutbound',
              label: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJOutbound.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJOutbound',
              label: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJOutbound.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJOutbound',
              label: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJOutbound.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJOutbound',
              label: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJOutbound.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
    }

    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.DebitNote) {
      // 3.3.1
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.Invoice) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            { key: 'relatedVatRecords', nestedKey: 'documentNumber', label: 'relatedInvoiceNumberSEF' },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInvoiceNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'turnoverAtTaxRate20S20ExceptPdvRsObj',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10ExceptPdvRsObj',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      // 3.3.2
      if (individualRecording.relatedInvoiceOption === RELATED_INVOICE_OPTION.PeriodSelection) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'receiverID' },
            'documentNumber',
            { key: 'relatedInvoiceOption', label: 'relatedInvoice' },
            'relatedInvoiceIssueDateFrom',
            'relatedInvoiceIssueDateTo',
          ],
          taxAmounts: [
            {
              title: 'turnoverAtTaxRate20S20ExceptPdvRsObj',
              label: 'turnoverAtATaxRateOf20.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10ExceptPdvRsObj',
              label: 'turnoverAtATaxRateOf10.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20S20PdvRsObj',
              label: 'turnoverAtTaxRate20S20PdvRsObj.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10S10PdvRsObj',
              label: 'turnoverAtTaxRate10S10PdvRsObj.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
    }
    //3.4
    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.PrepaymentInvoice) {
      return {
        basics: [
          { key: 'relatedPartyIdentifier', label: 'receiverID' },
          'documentNumber',
          'basisForPrepayment',
          'prepaymentDate',
        ],
        taxAmounts: [
          {
            title: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJOutbound',
            label: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJOutbound.tooltip',
            fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
          },
          {
            title: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJOutbound',
            label: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJOutbound.tooltip',
            fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
          },
          {
            title: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJOutbound',
            label: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJOutbound.tooltip',
            fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
          },
          {
            title: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJOutbound',
            label: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJOutbound.tooltip',
            fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
          },
        ],
      }
    }
  }
  if (individualRecording.documentDirection === DOCUMENT_DIRECTION.Inbound) {
    //4.1
    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.InternalAccountForTurnoverOfForeigner) {
      // Without Related Invoice 4.1.1.1
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Turnover) {
        if (individualRecording.relatedInternalInvoiceOption === RELATED_INTERNAL_INVOICE_OPTION.Empty) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJOther.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJOther.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate20ExceptOBJOther.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription20',
                  'noChargeNoRealEstateBaseAmount20',
                  'noChargeNoRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate10ExceptOBJOther.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription10',
                  'noChargeNoRealEstateBaseAmount10',
                  'noChargeNoRealEstateCalculatedVat10',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20OBJ',
                label: 'turnoverWithoutFeeAtTaxRate20OBJOther.tooltip',
                fields: [
                  'noChargeRealEstateDescription20',
                  'noChargeRealEstateBaseAmount20',
                  'noChargeRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10OBJ',
                label: 'turnoverWithoutFeeAtTaxRate10OBJOther.tooltip',
                fields: [
                  'noChargeRealEstateDescription10',
                  'noChargeRealEstateBaseAmount10',
                  'noChargeRealEstateCalculatedVat10',
                ],
              },
            ],
          }
        }
        //If Document selection: TURNOVER
        // With Related Invoice 4.1.1.2
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForPrepayment
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForPrepaymentNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForPrepaymentNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJOther.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJOther.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate20ExceptOBJOther.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription20',
                  'noChargeNoRealEstateBaseAmount20',
                  'noChargeNoRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate10ExceptOBJOther.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription10',
                  'noChargeNoRealEstateBaseAmount10',
                  'noChargeNoRealEstateCalculatedVat10',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20OBJ',
                label: 'turnoverWithoutFeeAtTaxRate20OBJOther.tooltip',
                fields: [
                  'noChargeRealEstateDescription20',
                  'noChargeRealEstateBaseAmount20',
                  'noChargeRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10OBJ',
                label: 'turnoverWithoutFeeAtTaxRate10OBJOther.tooltip',
                fields: [
                  'noChargeRealEstateDescription10',
                  'noChargeRealEstateBaseAmount10',
                  'noChargeRealEstateCalculatedVat10',
                ],
              },
            ],
          }
        }
      }
      //4.1.2
      //IF Document Selection: Prepayment
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Prepayment) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'senderId' },
            'internalInvoiceNumber',
            'internalInvoiceOption',
            'basisForPrepayment',
            'prepaymentDate',
          ],
          taxAmounts: [
            {
              title: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJInternal.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJInternal.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJInternal.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJInternal.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      //4.1.3
      //IF Document Selection: Debit
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Debit) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'senderId' },
            'internalInvoiceNumber',
            'internalInvoiceOption',
            'relatedInternalInvoiceOption',
            {
              key: 'relatedVatRecords',
              nestedKey: 'internalInvoiceNumber',
              label: 'relatedInternalAccountForTurnoverNumberSEF',
            },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForTurnoverNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'turnoverAtTaxRate20ExceptOBJ',
              label: 'turnoverAtTaxRate20ExceptOBJOther.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10ExceptOBJ',
              label: 'turnoverAtTaxRate10ExceptOBJOther.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20OBJ',
              label: 'turnoverAtTaxRate20OBJOther.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10OBJ',
              label: 'turnoverAtTaxRate10OBJOther.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      //4.1.4.1
      //IF Document Selection: Credit
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Credit) {
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForTurnover
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForTurnoverNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForTurnoverNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJOther.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJOther.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJOther.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
            ],
          }
        }
        //4.1.4.2
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForPrepayment
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForPrepaymentNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForPrepaymentNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'prepaymentForTurnoverAtTaxRate20ExceptOBJInternal',
                label: 'prepaymentForTurnoverAtTaxRate20ExceptOBJInternal.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate10ExceptOBJInternal',
                label: 'prepaymentForTurnoverAtTaxRate10ExceptOBJInternal.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate20OBJInternal',
                label: 'prepaymentForTurnoverAtTaxRate20OBJInternal.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate10OBJInternal',
                label: 'prepaymentForTurnoverAtTaxRate10OBJInternal.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
            ],
          }
        }
      }
    }
    //4.2
    if (individualRecording.documentType === VAT_RECORDING_DOCTYPE.OtherInternalStatement) {
      //4.2.1
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Turnover) {
        //4.2.1.1
        if (individualRecording.relatedInternalInvoiceOption === RELATED_INTERNAL_INVOICE_OPTION.Empty) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJ.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJ.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription20',
                  'noChargeNoRealEstateBaseAmount20',
                  'noChargeNoRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription10',
                  'noChargeNoRealEstateBaseAmount10',
                  'noChargeNoRealEstateCalculatedVat10',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20OBJ',
                label: 'turnoverWithoutFeeAtTaxRate20OBJ.tooltip',
                fields: [
                  'noChargeRealEstateDescription20',
                  'noChargeRealEstateBaseAmount20',
                  'noChargeRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10OBJ',
                label: 'turnoverWithoutFeeAtTaxRate10OBJ.tooltip',
                fields: [
                  'noChargeRealEstateDescription10',
                  'noChargeRealEstateBaseAmount10',
                  'noChargeRealEstateCalculatedVat10',
                ],
              },
            ],
          }
        }
        //4.2.1.2
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForPrepayment
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForPrepaymentNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForPrepaymentNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJ.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJ.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate20ExceptOBJ.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription20',
                  'noChargeNoRealEstateBaseAmount20',
                  'noChargeNoRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ',
                label: 'turnoverWithoutFeeAtTaxRate10ExceptOBJ.tooltip',
                fields: [
                  'noChargeNoRealEstateDescription10',
                  'noChargeNoRealEstateBaseAmount10',
                  'noChargeNoRealEstateCalculatedVat10',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate20OBJ',
                label: 'turnoverWithoutFeeAtTaxRate20OBJ.tooltip',
                fields: [
                  'noChargeRealEstateDescription20',
                  'noChargeRealEstateBaseAmount20',
                  'noChargeRealEstateCalculatedVat20',
                ],
              },
              {
                title: 'turnoverWithoutFeeAtTaxRate10OBJ',
                label: 'turnoverWithoutFeeAtTaxRate10OBJ.tooltip',
                fields: [
                  'noChargeRealEstateDescription10',
                  'noChargeRealEstateBaseAmount10',
                  'noChargeRealEstateCalculatedVat10',
                ],
              },
            ],
          }
        }
      }
      //4.2.2
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Prepayment) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'senderId' },
            'internalInvoiceNumber',
            'internalInvoiceOption',
            'basisForPrepayment',
            'prepaymentDate',
          ],
          taxAmounts: [
            {
              title: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate20ExceptPDVRSOBJ.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate10ExceptPDVRSOBJ.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate20PDVRSOBJ.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJ',
              label: 'prepaymentForTurnoverAtTaxRate10PDVRSOBJ.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      //4.2.3
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Debit) {
        return {
          basics: [
            { key: 'relatedPartyIdentifier', label: 'senderId' },
            'internalInvoiceNumber',
            'internalInvoiceOption',
            'relatedInternalInvoiceOption',
            {
              key: 'relatedVatRecords',
              nestedKey: 'internalInvoiceNumber',
              label: 'relatedInternalAccountForTurnoverNumberSEF',
            },
            { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForTurnoverNumberOutsideSEF' },
          ],
          taxAmounts: [
            {
              title: 'turnoverAtTaxRate20ExceptOBJ',
              label: 'turnoverAtTaxRate20ExceptOBJ.tooltip',
              fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10ExceptOBJ',
              label: 'turnoverAtTaxRate10ExceptOBJ.tooltip',
              fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
            },
            {
              title: 'turnoverAtTaxRate20OBJ',
              label: 'turnoverAtTaxRate20OBJ.tooltip',
              fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
            },
            {
              title: 'turnoverAtTaxRate10OBJ',
              label: 'turnoverAtTaxRate10OBJ.tooltip',
              fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
            },
          ],
        }
      }
      //4.2.4.1
      if (individualRecording.internalInvoiceOption === INTERNAL_INVOICE_OPTION.Credit) {
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForTurnover
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForTurnoverNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForTurnoverNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'turnoverAtTaxRate20ExceptOBJ',
                label: 'turnoverAtTaxRate20ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10ExceptOBJ',
                label: 'turnoverAtTaxRate10ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'turnoverAtTaxRate20OBJ',
                label: 'turnoverAtTaxRate20OBJ.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'turnoverAtTaxRate10OBJ',
                label: 'turnoverAtTaxRate10OBJ.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
            ],
          }
        }
        //4.2.4.2
        if (
          individualRecording.relatedInternalInvoiceOption ===
          RELATED_INTERNAL_INVOICE_OPTION.InternalAccountForPrepayment
        ) {
          return {
            basics: [
              { key: 'relatedPartyIdentifier', label: 'senderId' },
              'internalInvoiceNumber',
              'internalInvoiceOption',
              'relatedInternalInvoiceOption',
              {
                key: 'relatedVatRecords',
                nestedKey: 'internalInvoiceNumber',
                label: 'relatedInternalAccountForPrepaymentNumberSEF',
              },
              { key: 'relatedVatRecordOutOfSystem', label: 'relatedInternalAccountForPrepaymentNumberOutsideSEF' },
            ],
            taxAmounts: [
              {
                title: 'prepaymentForTurnoverAtTaxRate20ExceptOBJ',
                label: 'prepaymentForTurnoverAtTaxRate20ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription20', 'noRealEstateBaseAmount20', 'noRealEstateCalculatedVat20'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate10ExceptOBJ',
                label: 'prepaymentForTurnoverAtTaxRate10ExceptOBJ.tooltip',
                fields: ['noRealEstateDescription10', 'noRealEstateBaseAmount10', 'noRealEstateCalculatedVat10'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate20OBJ',
                label: 'prepaymentForTurnoverAtTaxRate20OBJ.tooltip',
                fields: ['realEstateDescription20', 'realEstateBaseAmount20', 'realEstateCalculatedVat20'],
              },
              {
                title: 'prepaymentForTurnoverAtTaxRate10OBJ',
                label: 'prepaymentForTurnoverAtTaxRate10OBJ.tooltip',
                fields: ['realEstateDescription10', 'realEstateBaseAmount10', 'realEstateCalculatedVat10'],
              },
            ],
          }
        }
      }
    }
  }
}

export const getKeyByValue = (obj, valueToFind) => Object.entries(obj).find(([, value]) => value === valueToFind)?.[0]
